import { useQuery } from "@tanstack/react-query";
import Alert from "@mui/material/Alert";
import { useIdentity } from "../auth/useIdentity";
import { getSetupStatus, trialBanner } from "../api/operatorSetup";

const holdsOwnerRole = (roles: string[]) => roles.some((r) => ["operator", "manager", "superadmin"].includes(r.toLowerCase()));

/**
 * The trial's end and what follows it, on every page for the operator's
 * owners (owner 2026-11-02). A read that fails shows nothing.
 */
export function TrialBanner() {
  const identity = useIdentity();
  const ns = identity.namespace ?? "";
  const enabled = Boolean(identity.token && ns && holdsOwnerRole(identity.roles));
  const status = useQuery({ queryKey: ["setup", ns], enabled, retry: false, queryFn: ({ signal }) => getSetupStatus(identity, ns, signal) });
  if (!enabled || !status.data) return null;
  const b = trialBanner(status.data, Date.now());
  if (!b) return null;
  return (
    <Alert severity={b.severity} sx={{ mb: 2 }} data-testid="trial-banner">
      {b.text}
    </Alert>
  );
}
